import { create } from "zustand"

interface RemakeDraft {
  name: string
  image: string | null
  invitees: any[]
}

interface CreateTeeupStore {
  isConfirmCreateTeeupPopupOpen: boolean
  setIsConfirmCreateTeeupPopupOpen: (flag: boolean) => void
  isInviteesError: boolean
  setIsInviteesError: (flag: boolean) => void
  // WN2 (Wave 4): one-shot prefill draft for "Remake TeeUp" from the inbox-card kebab menu
  // (TeeupTooltip), which lives outside the Create-TeeUp modal's own component tree. The modal
  // itself is already opened the normal way (dispatch(setIsCreateTeeupOpen(true)), the same
  // Redux action the sidebar's own "+" button uses -- no new open-mechanism needed).
  // CreateTeeUpProvider consumes remakeDraft once as its lazy initial state, then the kebab-menu
  // handler clears it via setRemakeDraft(null) right after dispatching the open action.
  remakeDraft: RemakeDraft | null
  setRemakeDraft: (draft: RemakeDraft | null) => void
}

export const useCreateTeeupStore = create<CreateTeeupStore>()(set => ({
  isConfirmCreateTeeupPopupOpen: false,
  setIsConfirmCreateTeeupPopupOpen: flag =>
    set({ isConfirmCreateTeeupPopupOpen: flag }),

  isInviteesError: false,
  setIsInviteesError: flag => set({ isInviteesError: flag }),

  remakeDraft: null,
  setRemakeDraft: draft => set({ remakeDraft: draft }),
}))
